import React from "react"
import { useInView } from "react-intersection-observer"
import { css } from "@jsUtils"

// eslint-disable-next-line no-unused-vars
import Styles from "./pagesection.module.scss"

/**
 * Generic wrapper for page sections
 * Can add class attributes etc. as necessary
 * @param {object} props - react props
 * @param {object} props.children - children
 * @param {string} props.theme - dark or light (default is light)
 * @param {boolean} props.ready - ready or not
 * @param {function} props.onReady - function to trigger on inView
 * @param {string} props.className - optional class to include
 */
const PageSection = props => {
  const { theme, children, ready, onReady, className, dataName, id } = props
  const [ref, inView] = useInView({
    /* Optional options */
    threshold: 0.0,
    rootMargin: "-150px 0px -150px 0px",
    triggerOnce: true
  })

  React.useEffect(() => {
    if (inView && !ready && onReady) {
      onReady()
    }
  }, [inView])

  return (
    <section
      className={css(Styles.pageSection, Styles[`theme_${theme}`], className)}
      id={id}
      ref={ref}
      data-name={dataName}
    >
      {children}
    </section>
  )
}

export default PageSection
